export const languages = ["en", "ru", "viet"];
